import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  ToggleButtonGroup,
  Grid,
  Button,
} from '@mui/material';
import { LinkedManufacturesAction, OverViewDetailAction } from './APIs/action';
import { toast } from 'react-toastify';
import ManufacturerDropdown from './Components/ManufacturerDropdown';
import { StyledToggleButton } from '../../Inventory/Inventory';
import BenefitLogo from './Assets/Bronze.png';
import { useNavigate } from 'react-router-dom';

const Overview = () => {
  const navigate = useNavigate(); //remove this
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedManufacturer, setSelectedManufacturer] = useState('');
  const [OverviewData, setOverviewData] = useState([]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const BenefitClubInfo = ({ clubs }) => (
    <Grid
      container
      spacing={2}
      sx={{ display: 'flex', flexDirection: 'row', mb: 2 }}
    >
      {clubs.map((club, index) => (
        <Grid
          key={index}
          item
          xs={12}
          sm={6}
          lg={4}
        >
          <Card
            sx={{
              border: '1px solid #0000001a',
              borderRadius: '10px',
              boxShadow: 'none',
              p: '10px !important',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box>
                  <img src={club?.logo} width={100} />
                </Box>
                <Box sx={{ ml: 1 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    {club.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      color: '#9B9B9B',
                      fontSize: '12px',
                    }}
                  >
                    {club.subtitle}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  variant='body2'
                  sx={{
                    color: club.description.color,
                    // border: `2px solid ${club.description.color}`,
                    background: `${club.description.color}33`,
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    px: '15px',
                    py: '5px',
                    fontSize: '12px',
                  }}
                >
                  {club.description.display_name}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const BenefitComparisonTable = ({ tableInfo }) => (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        border: '1px dashed #919eab33',
        borderRadius: '10px',
      }}
    >
      <Table sx={{ boxShadow: 'none' }}>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                borderBottom: 'none',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
              colSpan={5}
            >
              Benefit Comparison
            </TableCell>
          </TableRow>
        </TableHead>
        <TableHead>
          <TableRow
            sx={{ background: '#f4f6f8', borderBottom: '1px dashed #919eab33' }}
          >
            {tableInfo.table_header_keys.map((header, index) => (
              <TableCell
                sx={{
                  color: '#637381',
                  fontWeight: 'bold',
                  borderBottom: 'none',
                }}
                key={index}
              >
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableInfo.table_list_dtos.map((row, index) => (
            <TableRow
              key={index}
              sx={{ borderBottom: '1px dashed #919eab33' }}
            >
              {tableInfo.table_header_keys.map((header, headerIndex) => (
                <TableCell
                  sx={{ borderBottom: 'none', fontWeight: 'bold' }}
                  key={headerIndex}
                >
                  {row[header.value]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const fetchManufacturers = async () => {
    return await LinkedManufacturesAction();
  };
  const handleManufacturerChange = async (manufacturerId) => {
    const { data, message, error } = await OverViewDetailAction(manufacturerId);
    if (!error) {
      setOverviewData(data);
    } else {
      toast.error(message);
    }
  };

  useEffect(() => {
    selectedManufacturer && handleManufacturerChange(selectedManufacturer);
  }, [selectedManufacturer]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <ManufacturerDropdown
        fetchManufacturers={fetchManufacturers}
        onChange={handleManufacturerChange}
        selectedManufacturer={selectedManufacturer}
        setSelectedManufacturer={setSelectedManufacturer}
      />
      <ToggleButtonGroup
        value={selectedTab}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) handleTabChange(_, newValue);
        }}
        sx={{ mb: 2 }}
        aria-label='benefit selection'
      >
        {OverviewData.map((benefit, index) => (
          <StyledToggleButton
            key={index}
            value={index}
          >
            {benefit.display_name}
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>
      {OverviewData.map((benefit, index) => (
        <Box
          key={index}
          hidden={selectedTab !== index}
          sx={{ mb:2 }}
        >
          <BenefitClubInfo clubs={benefit.benefit_club_info} />
          <BenefitComparisonTable tableInfo={benefit.benefit_table_info} />
          <Button
            color='primary'
            variant='outlined'
            sx={{
              width: {
                xs: '100%',
                sm: 'auto',
              },
              mt: 2,
            }}
            onClick={
              () => navigate('/benefits/Tnc', {
              state: {
                tnc: benefit?.tnc,
              },
            })}
          >
            View Terms & Conditions
          </Button>
        </Box>
        
      ))}
      {/* @Manorma - tnc temp change for dalmia ,  Please remove this  logic  */}
      
    </Box>
  );
};

export default Overview;
